const PREFIX = '@prefs.';

// Strip a leftover disk prefix so get/set never write @prefs.@prefs.*.
const toLogicalKey = (key: string): string =>
  key.startsWith(PREFIX) ? key.slice(PREFIX.length) : key;

const k = (key: string) => `${PREFIX}${toLogicalKey(key)}`;

export const get = async (key: string): Promise<string | null> => {
  return window.localStorage.getItem(k(key));
};

export const set = async (key: string, value: string) => {
  window.localStorage.setItem(k(key), value);
};

export const remove = async (key: string) => {
  window.localStorage.removeItem(k(key));
};

export const clear = async () => {
  window.localStorage.clear();
};

// Canonical contract: unprefixed string[]. Per rule: architecture-principles
// (ai.knowledge/global) — Electron and web expose the same keys() shape.
export const keys = async (): Promise<string[]> => {
  return Object.keys(localStorage)
    .filter((key) => key.startsWith(PREFIX))
    .map(toLogicalKey);
};
